import { DateTime } from 'luxon';
import humanize from 'humanize-duration';

import { Model } from '@app/models/model';
import { config } from '@config/config';
import { User } from '@app/models/users/users.model';
export class BatteryOrder extends Model {
    link: string;
    type: string;
    price: string;

    constructor(input: any) {
        super(input);
    }
}
